import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import OpportunitiesUsersAdmin from './OpportunitiesUsersAdmin'
import { ListDivider } from 'rmwc/List';
import { Button, ButtonIcon } from 'rmwc/Button';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import OpportunityForm from '../opportunities/OpportunityForm'
import SerializeForm from 'form-serialize'
import {stateToHTML} from 'draft-js-export-html';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import {Editor as DiffEditor} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';


import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';

class OpportunitiesAdmin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      listUsers: false,
      selectedOpportunity : '',
      opportunityTypes: [],
      selectedTypeId: '',
      data: {
        opportunities: [],
        applied: [],
        queryStr: '',
        searchResults: [],
        sortFilter: '',
        OpportunityId: '',
        editOpportunity: false
      },
      editorData: {
        editorStateRead: EditorState.createEmpty()
      }
    }

    this.handleApply = this.handleApply.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleQueryChange = this.handleQueryChange.bind(this)
    this.handleSort = this.handleSort.bind(this)
  }


  componentDidMount() {
    return
    var prms = [];
    var prm = api.getOpportunities(this.props.user.accessToken)
    prms.push(prm)

    prm = api.getAppliedOpportunities(this.props.user.accessToken)
    prms.push(prm)

    prm = api.getOpportunityTypes(this.props.user.accessToken)
    prms.push(prm)

    Promise.all(prms)
    .then((results) => {
      let data = Object.assign({}, this.state.data)
      data.opportunities = results[0].data
      data.applied = results[1]
      let opportunityTypes = results[2]
      data.searchResults = data.opportunities.map(opportunity => opportunity.id)
      this.setState({data: data, opportunityTypes: opportunityTypes})
      //console.log(data.opportunities)
    })
    .catch((err) => {
    // console.log(`error:${err.stack}`)
      console.log("err + " + err.stack)
      this.setState({ message: err.stack })
    })
  }

  handleApply(event) {
    var opportunityId = Number(event.target.name);
    return api.applyForOpportunity(this.props.user.accessToken, opportunityId)
    .then((result) => {
      console.log("result = " + JSON.stringify(result))
      if (result.status === "success") {
        let data = Object.assign({}, this.state.data)
        data.applied.push(opportunityId)
        console.log("data.applied = " + JSON.stringify(data.applied));
        this.setState({data: data})
      }
    })
    .catch((err) => {
    // console.log(`error:${err.stack}`)
      console.log("err + " + err.stack)
      this.setState({ message: err.stack })
    })
  }

  handleQueryChange(event) {
    let data = Object.assign({}, this.state.data)
    data.queryStr = event.target.value
    this.setState({data: data})
  }

  handleSearch(event) {
    if (this.state.data.queryStr) {
      return api.searchOpportunities(this.props.user.accessToken, this.state.data.queryStr)
      .then((result) => {
        if (result.status === "success") {
          console.log("searchResults = " + result.data)
          let data = Object.assign({}, this.state.data)
          data.searchResults = result.data
          this.setState({data: data, selectedTypeId:''})
        }
      })
      .catch((err) => {
      // console.log(`error:${err.stack}`)
        console.log("err + " + err.stack)
        this.setState({ message: err.stack })
      })
    } else {
      let data = Object.assign({}, this.state.data)
      data.searchResults = data.opportunities.map(opportunity => opportunity.id)
      this.setState({data: data})
    }
  }


  handleClear = () => {
    let data = Object.assign({}, this.state.data)
    data.searchResults = data.opportunities.map(opportunity => opportunity.id)
    data.queryStr = ''
    this.setState({data: data})
  }

  handleSort(event) {
    console.log("In handleSort:" + event.target.value)
    let data = Object.assign({}, this.state.data)
    data.sortFilter = event.target.value
    this.setState({ data: data})
  }

  editOpportunity = (event) => {
    var opportunityId = Number(event.target.name);
    let data = Object.assign({}, this.state.data)
    data.OpportunityId = opportunityId
    data.editOpportunity = true
    this.setState({ data: data})
  }

  handleFormUpdate = (formData) => {
    //e.preventDefault()
    //const formData = SerializeForm(e.target, { hash: true })
    api.updateOpportunity(this.props.user.accessToken,formData)
    .then((result) => {
      let opportunities = this.state.data.opportunities.map((opportunity) => {
        if (opportunity.id === result.id) {
          return Object.assign({}, opportunity, {
            organization: result.organization? result.organization: '',
            position: result.position? result.position : '',
            location: result.location ? result.location: '',
            cutOffDate: result.cutOffDate ? result.cutOffDate: '',
            salary: result.salary ? result.salary : '',
            status: result.status ? result.status : '',
            jobDescription: result.jobDescription? result.jobDescription : '',
            websiteLink: result.websiteLink? result.websiteLink : '',
            postApplyMsg: result.postApplyMsg? result.postApplyMsg : '',
            orgImgLink: result.orgImgLink? result.orgImgLink : '',
            listingSequence: result.listingSequence? result.listingSequence : '',
            opportunityTypeName: result.opportunityTypeName? result.opportunityTypeName : '',
            categories: result.categories? result.categories : '',
            active: result.active,
            emailTemplateId: result.emailTemplateId? result.emailTemplateId : ''
          });
        } else {
          return opportunity;
        }
      });
      let data = Object.assign({}, this.state.data)
      data.searchResults = data.opportunities.map(opportunity => opportunity.id)
      data.opportunities = opportunities
      data.OpportunityId = ''
      data.editOpportunity = false
      this.setState({data: data})
    })
    .catch((err) => {
    // console.log(`error:${err.stack}`)
      this.setState({ errorMsg: err.stack })
    })
  }


  listUsers = (e) =>{
    e.preventDefault()
    var opportunityId = Number(e.target.name);
    this.setState({listUsers:true, selectedOpportunity:opportunityId})
  }

  listOpportunities = () =>{
    this.setState({listUsers:false})
  }

  handleOpportunityTypeChange = (event) =>{

    let opportunityTypeId
    
    if(!event.target.value){
      opportunityTypeId = 0
    }else{
      opportunityTypeId = event.target.value
    }
    
    let search_return_all_values = 'No'
    return api.searchByOpportunityType(this.props.user.accessToken, opportunityTypeId, search_return_all_values)
      .then((result) => {
        if (result.status === "success") {
          console.log('inside success status of type')
          let data = Object.assign({}, this.state.data)
          data.searchResults = result.data
          data.queryStr = ''
          this.setState({data: data, selectedTypeId: opportunityTypeId})
        }
      })
      .catch((err) => {        
        this.setState({ message: err.stack })
    })

  }

  render() {
    let filtered = this.state.data.opportunities.filter(opportunity => 
          this.state.data.searchResults.indexOf(opportunity.id) != -1);
    let order = {}
    this.state.data.searchResults.forEach(function (a, i) { order[a] = i; });
    filtered.sort(function(a,b) {return order[a.id] - order[b.id];});
    if (this.state.data.sortFilter) {
      switch(this.state.data.sortFilter) {
        case 'salary_asc':
          filtered.sort(function(a, b) {return a.salary - b.salary}); break;
        case 'salary_desc':
          filtered.sort(function(a, b) {return b.salary - a.salary}); break;
        case 'cut_off_date_asc':
          filtered.sort(function(a, b) {return new Date(a.cut_off_date) - new Date(b.cut_off_date)}); break;
        case 'cut_off_date_desc':
         filtered.sort(function(a, b) {return new Date(b.cut_off_date) - new Date(a.cut_off_date)}); break;
        case 'relevance':
          break;
      }        
    }
    let opportunityAddButton
    let isAdmin = false

    if(this.props.user.role=='admin'){

      isAdmin = true
      opportunityAddButton =<Button >
                <Link to="/portal/app/opportunities/new">
                  Add Opportunity
                </Link>
              </Button>
    }

    if(this.state.listUsers && isAdmin){
      return (
          <div key={this.state.selectedOpportunity.id}>
            <OpportunitiesUsersAdmin opportunityId={this.state.selectedOpportunity} onViewOpportunities ={this.listOpportunities}/>
          </div>
        )

    }

    if (!this.state.data.editOpportunity && isAdmin) {

      let editorData = this.state.editorData
      let editOpportunity = this.editOpportunity
      let listUsers = this.listUsers
      let filteredOpportunityList
      
      filteredOpportunityList = ( <Grid>
        {filtered.map(function(opportunity){

            let contentValue = convertFromHTML(opportunity.jobDescription)
            const contentState = ContentState.createFromBlockArray(contentValue);
            editorData.editorStateRead = EditorState.createWithContent(contentState);


          
            return ( 
              
              <GridCell span="12">
                <Card style={{'padding-left': '25px'}}>
                  <Grid className="opportunity-list-item">
                    <GridCell span="6">
                     
                       <Typography use="subtitle2"> {opportunity.position} </Typography>
                     
                    </GridCell>

                    <GridCell span="3">
                      <Typography use="subtitle2"> Apply by: {opportunity.cutOffDate}</Typography>
                    </GridCell>
                    
                    <GridCell span="3">
                      <Typography use="subtitle2"> Status: {opportunity.status} </Typography>
                    </GridCell>

                    <GridCell span="6">
                      <Typography use="body2"> Organization: {opportunity.organization}</Typography>
                    </GridCell>
                    
                    <GridCell span="3">
                      <Typography use="body2"> Location: {opportunity.location} </Typography>
                    </GridCell>

                    <GridCell span="3">
                      <Typography use="body2"> Salary(INR): {opportunity.salary} </Typography>
                    </GridCell>

                    <GridCell span="12">
                      <Typography use="body2"> Job Description:</Typography>
                      <DiffEditor editorState={editorData.editorStateRead} readOnly/>
                    </GridCell>

                    <GridCell span="6">
                      <Typography use="body2"> Type: {opportunity.opportunityTypeName} </Typography>
                    </GridCell>
                    <GridCell span="6">
                      <Typography use="body2"> Categories: {opportunity.categories} </Typography>
                    </GridCell>

                    <GridCell span="6">
                      <Typography use="body2"> Website: </Typography>
                      
                      
                    {(opportunity.websiteLink !== undefined) > 0  ? 
                 <Typography use="body2"> <a href={opportunity.websiteLink} target="_blank" style={{cursor: 'pointer'}}> View </a> </Typography>
                 :<Typography use="body2"> N/A </Typography>
                    }
               

                    </GridCell>

                    <GridCell span="6"> <Typography use="body2"> Active: </Typography> 
                       {(opportunity.active === true) ? 
                        <Typography use="body2">  Active </Typography>
                        :<Typography use="body2"> Not Active </Typography>
                        }

                    </GridCell>

                    <GridCell span="6">
                      <Typography use="body2"> Log Link: </Typography>
                    {(opportunity.orgImgLink !== undefined) > 0  ? 
                 <Typography use="body2"> <a href={opportunity.orgImgLink} target="_blank" style={{cursor: 'pointer'}}> View </a> </Typography>
                 :<Typography use="body2"> N/A </Typography>
                    }
                    </GridCell>

                    <GridCell span="6">
                      <Typography use="body2"> Listing Sequence: {opportunity.listingSequence} </Typography>
                    </GridCell>

                    <GridCell span="6">
                      <Typography use="body2"> Post Apply Message: {opportunity.postApplyMsg} </Typography>
                    </GridCell>

                    <GridCell span="6">
                      <Typography use="body2"> Email Template Id: {opportunity.emailTemplateId} </Typography>
                    </GridCell>


                    <GridCell span="2">
                     
                      <CardAction onClick={editOpportunity} name={opportunity.id}>Edit</CardAction>
                     
                    </GridCell>
                    <GridCell span="3">
                     
                      <CardAction onClick={listUsers} name={opportunity.id}>View Users</CardAction>
                     
                    </GridCell>
                  </Grid>
                </Card>
              </GridCell>
              
            )
          
          })} 

      
      </Grid>) //end 

      return (<div>
        
        <Grid>
          <GridCell span="12">
            <Card style={{'padding-left': '25px', 'background-color': '#f7f7f7'}}>
              <Grid className="opportunity-list-item">
                
                <GridCell span="4">
                  <Typography use="headline6"> Opportunities </Typography>
                </GridCell>

                <GridCell span="4">
                  {opportunityAddButton}
                </GridCell>

                <GridCell span="4">
                  
                </GridCell>

                <GridCell span="4">
                  <TextField fullwidth className='text_input' label="Enter Keyword" value={this.state.data.queryStr} onChange={this.handleQueryChange}/>
                  
                </GridCell>
                <GridCell span="1">
                  <br/>
                  <Button onClick={this.handleSearch}>Search</Button>
                </GridCell>

                <GridCell span="1">
                  <br/>
                  <Button onClick={this.handleClear}>Clear</Button>
                </GridCell>

                <GridCell span="2">
                  
                </GridCell>

                <GridCell span="4">
                
                   <Select
                     name="opportunityTypeId"
                    onChange={this.handleOpportunityTypeChange}
                    value={this.state.selectedTypeId}
                    className="select-component"
                    placeholder="-- Search By Type --"
                  >
                    {this.state.opportunityTypes.map(level => (
                      <option key={level.id} value={level.id} data-name={level.name}>
                        {level.name}
                      </option>
                    ))}
                  </Select>
                </GridCell>
                <GridCell span="12">
                    <ListDivider/>
                  </GridCell>
                <GridCell span="6">
                  <label>Sort by:  </label>
                  <select 
                    label="Sort By"
                    onChange={this.handleSort} 
                    value={this.state.data.sortFilter}
                  >
                    <option value="Relevance">Relevance</option>
                    <option value="salary_asc">Salary Asc</option>
                    <option value="salary_desc">Salary Desc</option>
                  </select>
                </GridCell>

                
              </Grid>
            </Card>
          </GridCell>
        </Grid>

           
          {filteredOpportunityList}
        
        </div>
      )
    }else if (isAdmin){
      return (
        <OpportunityForm  
          oppertunityId={this.state.data.OpportunityId}
          onFormSubmit={this.handleFormUpdate}
          userToken = {this.props.user.accessToken}
        />
      )
    }else{
      return (
          <div>
            Access denied
          </div>
        )
    }
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(OpportunitiesAdmin);


// WEBPACK FOOTER //
// ./src/views/admin/OpportunitiesAdmin.jsx